import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Class } from '../../../data/class';
import { Student } from '../../../data/student';
import { BaseComponent } from '../../../base/base.component';
import { json2csv } from 'json-2-csv';
import { FileUtilities } from '../../../utilities/file-utilities';
import { DatepickerViewModel } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model';

@Component({
  selector: 'app-report-with-dates-include-no-activity-old',
  templateUrl: './report-with-dates-include-no-activity-old.component.html',
  styleUrls: ['./report-with-dates-include-no-activity-old.component.scss']
})
export class ReportWithDatesIncludeNoActivityOldComponent extends BaseComponent implements OnInit {
  
  organizationID: number;
  startDate: string;
  endDate: string;
  running = false;

  getResult(): void {
    this.running = true;
    this.dataService.getReportWithDatesIncludeNoActivityOld(this.organizationID, this.startDate, this.endDate).subscribe(json => {
      this.running = false;
      json2csv(json, (err, csv) => {
        FileUtilities.saveFile(csv, 'ReportWithDatesIncludeNoActivityOld_' + this.organizationID + '.csv', 'text/csv');
       });
    });
  }
}
